import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import { useSelector } from 'react-redux'

import styles from './LinkSection.module.scss'
import { getHasImpressumPage } from 'pages/ChannelPage/Impressum/getHasImpressumPage'
import { languageSelector } from 'redux-store/language/language.selectors'
import { getTermsLink } from '../../getTermsLink'

interface Impressum {
  subdomain: string
}

interface ChannelCountry {
  code: string
}

interface Props {
  impressum: Impressum
  channelSlug: string
  channelCountry: ChannelCountry
}

export const LinkSection: FC<Props> = ({
  impressum,
  channelSlug,
  channelCountry
}) => {
  const impressumPageSubdomain = impressum?.subdomain || channelSlug
  const hasImpressumPage = getHasImpressumPage(channelCountry?.code)
  const currentLanguage = useSelector(languageSelector)
  return (
    <div className={styles.LinkSectionContainer}>
      <a
        className={styles.Link}
        target="_blank"
        href="https://solidsport.freshdesk.com/en/support/home"
        rel="noreferrer"
      >
        <Trans>Support</Trans>
      </a>
      <a
        className={styles.Link}
        target="_blank"
        href={getTermsLink(currentLanguage)}
        rel="noreferrer"
      >
        <Trans>Terms &amp; Policy</Trans>
      </a>
      {hasImpressumPage && (
        <a
          className={styles.Link}
          href={`/${impressumPageSubdomain}/impressum`}
        >
          <Trans>Impressum</Trans>
        </a>
      )}
    </div>
  )
}
